import store from '@/store'

const userHasPermissionByRole = (userRoles, routeRoles) => {
  if (!routeRoles || routeRoles.length == 0) { return true }

  return routeRoles.some(r => userRoles.includes(r))
}
export default (router) => {
  router.beforeEach((to, from, next) => {
    const authRequired = to.matched.some(record => record.meta.auth)
    const isAuthenticated = store.getters['auth/isAuthenticated']
    const roles = store.getters['auth/roles']
    const hasPermissions = authRequired
      ? isAuthenticated && userHasPermissionByRole(roles, to.meta.roles)
      : true

    return hasPermissions
      ? next()
      : next({ path: '/welcome' })
  })
}